/*--------------------------------------
BANNER CLICKS
 --------------------------------------*/
BannerClicks = {
  init: function () {
    if ($('.header-banner').hasClass("open")) {
      $("body").addClass("announcement-bar-open");
    };

    $(".header-banner__close-btn").click(function () {
      $(".header-banner").removeClass("open");
      $("body").removeClass("announcement-bar-open");
    });




  }
};

$(document).ready(function () {
  BannerClicks.init();

  new Swiper(".banner-mobile-swiper", {
    loop: true,
    freeMode: true,
    spaceBetween: 0,
    grabCursor: false,
    allowTouchMove: false,
    slidesPerView: "auto",
    loop: true,
    autoplay: {
      delay: 1,
      disableOnInteraction: false
    },
    freeMode: true,
    speed: 10000,
    freeModeMomentum: false
  });
});